const config = {
  apiUrl: "https://api-automation.sunbit.in",
  launchDarklyClientId: '64a3d3e354eaac132a049129',
};

export default config;



// WEBPACK FOOTER //
// ./src/config/automation.js